import { render, staticRenderFns } from "./IngredientDatas.vue?vue&type=template&id=ed2bb08c&"
import script from "./IngredientDatas.vue?vue&type=script&lang=js&"
export * from "./IngredientDatas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports